import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));

export default function YesNoQuestion() {
  const classes = useStyles();

  return (
    <Grid direction="row" className={classes.root}>
      <Button variant="outlined">
        Yes
      </Button>
      <Button variant="outlined" color="primary">
        No
      </Button>
     
    </Grid>
  );
}
